// extracted by mini-css-extract-plugin
export default {"appPresentation":"AppPresentation_appPresentation__hVVkm"};